const actions = {
  // addCuenta(context, cuenta) {
  //   return context.commit('CUENTA_NEW', cuenta)
  // },
  // addPedido(context, pedido) {
  //   return context.commit('PEDIDO', pedido)
  // },
}

export { actions }
